import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Close.svg'

export const IconClose = IconSVG as IconComponent
